export default __webpack_public_path__ + "static/media/4.3cb871de.jpg";